/**
 * CitizenshipSection - US citizen radio, country/immigration (conditional),
 * transfer bond radio + description (conditional)
 */

import { OathInput } from '../../../shared/OathUI';

const CitizenshipSection = ({ formState, dispatch, disabled }) => {
  const set = (field) => (val) => dispatch({ type: 'SET_FIELD', field, value: val });

  return (
    <div>
      <h4 className="font-medium text-gray-900 dark:text-white mb-3">Citizenship & Transfer Bond</h4>
      <div className="space-y-4">
        {/* US Citizen */}
        <div>
          <label className="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">
            Is the defendant a US Citizen?
          </label>
          <div className="flex gap-4">
            <label className="flex items-center gap-2 text-sm text-gray-700 dark:text-gray-300">
              <input
                type="radio"
                name="isUsCitizen"
                checked={formState.isUsCitizen === true}
                onChange={() => {
                  dispatch({ type: 'SET_FIELD', field: 'isUsCitizen', value: true });
                  dispatch({ type: 'SET_FIELD', field: 'countryOfOrigin', value: '' });
                  dispatch({ type: 'SET_FIELD', field: 'immigrationStatus', value: '' });
                  dispatch({ type: 'SET_FIELD', field: 'citizenDescription', value: '' });
                }}
                disabled={disabled}
                className="accent-primary"
              />
              Yes
            </label>
            <label className="flex items-center gap-2 text-sm text-gray-700 dark:text-gray-300">
              <input
                type="radio"
                name="isUsCitizen"
                checked={formState.isUsCitizen === false}
                onChange={() => dispatch({ type: 'SET_FIELD', field: 'isUsCitizen', value: false })}
                disabled={disabled}
                className="accent-primary"
              />
              No
            </label>
          </div>
        </div>

        {/* Conditional citizenship fields */}
        {formState.isUsCitizen === false && (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3">
            <OathInput
              label="Country of Origin"
              value={formState.countryOfOrigin}
              onChange={set('countryOfOrigin')}
              placeholder="Country"
              required
              disabled={disabled}
            />
            <OathInput
              label="Immigration Status"
              value={formState.immigrationStatus}
              onChange={set('immigrationStatus')}
              placeholder="Status"
              required
              disabled={disabled}
            />
            <div className="sm:col-span-2 md:col-span-3">
              <OathInput
                label="Description"
                value={formState.citizenDescription}
                onChange={set('citizenDescription')}
                placeholder="Additional details"
                disabled={disabled}
              />
            </div>
          </div>
        )}

        {/* Transfer Bond */}
        <div>
          <label className="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">
            Is this a Transfer Bond?
          </label>
          <div className="flex gap-4">
            <label className="flex items-center gap-2 text-sm text-gray-700 dark:text-gray-300">
              <input
                type="radio"
                name="isTransferBond"
                checked={formState.isTransferBond === true}
                onChange={() => dispatch({ type: 'SET_FIELD', field: 'isTransferBond', value: true })}
                disabled={disabled}
                className="accent-primary"
              />
              Yes
            </label>
            <label className="flex items-center gap-2 text-sm text-gray-700 dark:text-gray-300">
              <input
                type="radio"
                name="isTransferBond"
                checked={formState.isTransferBond === false}
                onChange={() => {
                  dispatch({ type: 'SET_FIELD', field: 'isTransferBond', value: false });
                  dispatch({ type: 'SET_FIELD', field: 'tbondOriginDescription', value: '' });
                }}
                disabled={disabled}
                className="accent-primary"
              />
              No
            </label>
          </div>
        </div>

        {/* Conditional transfer bond description */}
        {formState.isTransferBond === true && (
          <OathInput
            label="What county and state will this bond be posted in?"
            value={formState.tbondOriginDescription}
            onChange={set('tbondOriginDescription')}
            placeholder="County, State"
            required
            disabled={disabled}
          />
        )}
      </div>
    </div>
  );
};

export default CitizenshipSection;
